export enum KeyCodes {
  ENTER = 13,
}

export enum KeyValues {
  ENTER = 'enter',
  SPACE = ' ',
  COMMA = ',',
}
